import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DialogContent from '@mui/material/DialogContent';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useCommandSetOverride } from '../../../../../../../../app/ApiGen';
import { Dialog } from '../../../../../../../../components/Dialog';
import { errorSnackbar } from '../../../../../../../../components/ErrorSnackbar';
import { FormActions } from '../../../../../../../../design-system';
import { useChargePoint } from '../../../Provider';
import { ChargeNowDialogProps } from '../../types/chargeNow';

export const ChargeNowDialog: React.FC<ChargeNowDialogProps> = ({
  isOpen,
  onClose,
  connectorId,
}: ChargeNowDialogProps) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const { chargePoint, refetch } = useChargePoint();
  const { id: chargePointId } = chargePoint ?? { id: '' };

  const { mutate, loading } = useCommandSetOverride({
    id: chargePointId,
  });

  const onSubmit = React.useCallback(() => {
    mutate({ connectorId: parseInt(connectorId, 10), chargeNow: true })
      .then(() => {
        onClose();
        enqueueSnackbar(`Charge now command sent to connector ${connectorId}`);
        refetch();
      })
      .catch((error) => {
        onClose();
        errorSnackbar('Unable to send charge now command', closeSnackbar, enqueueSnackbar, error);
      });
  }, [connectorId, mutate, enqueueSnackbar, onClose, refetch, closeSnackbar]);

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title={`Send charge now command to connector ${connectorId}`}>
      <DialogContent>
        When network load is high we limit charging to reduce the use of high CO2 emission generation. You can override
        this if charging is needed.
      </DialogContent>
      <FormActions>
        <Button color="primary" variant="contained" disabled={loading} onClick={onSubmit}>
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Send command'}
        </Button>
      </FormActions>
    </Dialog>
  );
};
